"use client";

import { HStack, RadioGroup } from "@chakra-ui/react";

const RadioInput = ({ items, value = "1", onChange, disabled }) => {
  return (
    <RadioGroup.Root
      value={value}
      onValueChange={(e) => onChange(e.value)}
      disabled={disabled}
    >
      <HStack gap="6">
        {items.map((item) => (
          <RadioGroup.Item key={item.value} value={item.value}>
            <RadioGroup.ItemHiddenInput />
            <RadioGroup.ItemIndicator />
            <RadioGroup.ItemText>{item.label}</RadioGroup.ItemText>
          </RadioGroup.Item>
        ))}
      </HStack>
    </RadioGroup.Root>
  );
};

export default RadioInput;
